import Slider from "../../../../../../../library/slider";
import { useAppSelector } from "../../../../../../../redux/hooks";

import { getIcon } from "../../../../../../../utils/get-icon";
import { useSettings } from "../../../context";
import {
  ContentWrapper,
  ResetButton,
  SliderIcon,
  SliderWrapper,
} from "./styled";

const PositionConfiguration = () => {
  const { updatePositionSettings, getSelectedItemSettings } = useSettings();
  const video = useAppSelector((state) => state.transcript.data);

  const currentSettings = getSelectedItemSettings();

  const handleXChange = (value: number | number[]) => {
    const val = Array.isArray(value) ? value[0] : value;
    if (!isNaN(val)) {
      updatePositionSettings({ x: val });
    }
  };

  const handleYChange = (value: number | number[]) => {
    const val = Array.isArray(value) ? value[0] : value;
    if (!isNaN(val)) {
      updatePositionSettings({ y: val });
    }
  };

  return (
    <ContentWrapper>
      <SliderWrapper>
        <SliderIcon>{getIcon("position-x")}</SliderIcon>
        <Slider
          min={0}
          max={video.size?.width}
          value={currentSettings.position.x}
          onChange={handleXChange}
          dots={false}
        />
        <ResetButton>{getIcon("reset")}</ResetButton>
      </SliderWrapper>
      <SliderWrapper>
        <SliderIcon>{getIcon("position-y")}</SliderIcon>
        <Slider
          min={0}
          max={video.size?.height}
          value={currentSettings.position.y}
          onChange={handleYChange}
          dots={false}
        />
        <ResetButton>{getIcon("reset")}</ResetButton>
      </SliderWrapper>
    </ContentWrapper>
  );
};

export default PositionConfiguration;
